import React from 'react';

export const ExcelIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-excel"
      style={{ color: '#2F9E44', ...props.style }}
    />
  );
};
